import { useQuery } from '@apollo/client'
import { isEmpty, uniq } from 'lodash'
import { useState, useEffect } from 'react'
import { useIntl, defineMessages } from 'react-intl'

import { Autocomplete } from 'components/v2/Autocomplete'
import { GET_PLACES_AREA } from 'features/Places/queries-legacy'
import { GTTPlacesResponse } from 'gql/types.generated'

const messages = defineMessages({
  newLabel: {
    id: 'areas.suggestion.newLabel',
    defaultMessage: '(New label)'
  }
})

export const SelectAreaSuggestion = (props: TSFixMe): TSFixMe => {
  const intl = useIntl()
  const [pattern, setPattern] = useState('')
  const { data, loading, refetch } = useQuery<{ tplaces: GTTPlacesResponse }>(GET_PLACES_AREA, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      pagination: {
        page: 1,
        size: 10000
      }
    }
  })

  useEffect(() => {
    refetch()
  }, [])

  const filteredExistingItems =
    data?.tplaces.items
      .filter((place: TSFixMe): TSFixMe => {
        return place.area && place.area.toLowerCase().indexOf(pattern.toLowerCase()) > -1
      })
      .map(({ area }: TSFixMe): TSFixMe => area) || []

  let shownItems = [...filteredExistingItems]

  if (pattern) {
    shownItems = [pattern, ...shownItems]
  }

  const handleChange = (area: TSFixMe, { inputValue = '' } = {}): TSFixMe => {
    setPattern(inputValue)

    if (!isEmpty(area)) {
      props.onChange(area)
    } else {
      props.onChange(inputValue)
    }
  }

  return (
    <Autocomplete
      {...props}
      items={uniq(shownItems)}
      getItemLabel={(area): TSFixMe => {
        if (filteredExistingItems.indexOf(area) > -1) {
          return area
        }

        return `${area} ${intl.formatMessage(messages.newLabel)}`
      }}
      loading={loading}
      onChange={handleChange}
    />
  )
}
